import React, { useCallback } from 'react';
import { useTranslation } from 'next-i18next';
import CopyToClipboard from 'react-copy-to-clipboard';

import MiddleEllipsis from 'src/ui/common/molecules/middle-ellipsis';
import { SvgIcon } from 'src/ui/common/atoms/svg-icon';
import TooltipComponent from 'src/ui/common/organisms/tooltip/tooltip.component';
import { useNotifications } from 'src/services/notifications/use-notifications';
import { Typography } from 'src/ui/common/atoms/typography';
import { StyledWalletWrapper, StyledWallet } from './styles';

export const WalletColumn: React.VFC<{ text: string }> = ({ text }) => {
    const { t } = useTranslation('common');
    const { success } = useNotifications();

    const handleCopy = useCallback(() => {
        success({ text: t('status.copied', { ns: 'common' }), timeout: 2000 });
    }, [t, success]);

    return (
        <TooltipComponent content={<Typography overflowLines={2}>{text}</Typography>}>
            <StyledWalletWrapper>
                <CopyToClipboard text={text} onCopy={handleCopy}>
                    <StyledWallet alignItems='center'>
                        <div>
                            <MiddleEllipsis text={text} />
                        </div>
                        <SvgIcon variant='regular' icon='copy' />
                    </StyledWallet>
                </CopyToClipboard>
            </StyledWalletWrapper>
        </TooltipComponent>
    );
};
